import { useContextMotifDetails } from '../../contexts/motifDetailsContext'

export const TotalMotifCount = () => {
  const { allMotifs } = useContextMotifDetails()

  return <p>*={allMotifs.length}</p>
}
